// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LOS ARCHIVOS DENTRO DE LA APP DEL MÓVIL: AL VISOR DE LA APP, NUNCA A UN <a download> QUE NO HACE NADA   (17-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «En dispositivos móviles no se puede abrir un PDF enviado por chat interno; comprobar que el resto de archivos se
//  pueden abrir. Pasa con la app, ya que en el ordenador, por el navegador, sí funciona». El chat de equipo
//  (components/chat/MensajeChat, pages/ChatEquipo) y el chat de soporte (components/ChatWidget) bajaban cada adjunto con un
//  <a download> sobre una dirección blob:, y la vista web de la app (Capacitor, en el iPhone y en Android) NO descarga: se
//  pulsaba y no pasaba nada. Las fotos, con window.open() sobre esa dirección: tampoco. El arreglo del 16-oct (el «Descargar»
//  del visor, utils/descargaFuera) no llegaba nunca ahí, porque el chat no pasaba por el visor.
//
//  Dos piezas, las dos SOLO dentro de la app nativa (en un navegador, también el del teléfono, todo sigue igual):
//   · `verAdjuntoEnLaApp`: el chat abre el adjunto en el visor de la app (components/VisorDocumentoGlobal): las fotos en el de
//     imágenes; los PDF, página a página; el vídeo y el audio, con su reproductor; y lo demás (Word, Excel, zip…) con su
//     botón «Descargar», que lo pasa al navegador del teléfono (utils/descargaFuera).
//   · `instalarDescargasEnLaApp` (main.jsx, una vez): CUALQUIER <a download> con una dirección blob: o data: —pulsado, o con
//     .click() desde el código, como hacen decenas de pantallas (exportaciones, documentos del laboratorio, la conversación
//     exportada…)— se desvía a ese mismo visor. Una pantalla que suelta la dirección justo después del click no se queda sin
//     fichero: aquí se recuerda qué Blob hay detrás de cada dirección blob: hasta GRACIA_SOLTAR_MS después de soltarla.
//     Un enlace que ya sabe salir solo de la app (el «Descargar» del visor de imágenes) lleva `data-descarga-propia`.
//  Lo mide backend/routes/chat-adjuntos-se-abren-en-la-app.test.js, tipo por tipo.
import { enLaAppNativa, verDocumentoEnLaApp } from './verDocumento'

export const MARCA = '__biangoDescargasEnLaApp'
export const GRACIA_SOLTAR_MS = 30000
const RE_DIRECCION_LOCAL = /^(blob|data):/i

const ventanaDe = (ventana) => ventana || (typeof window !== 'undefined' ? window : null)

// El Blob que hay detrás de una dirección blob: creada en la app (o null si no se sabe).
function blobRecordado(w, url) {
  const r = w && w[MARCA]
  return (r && r.blobs && r.blobs.get(String(url || ''))) || null
}

// Enseña en el visor de la app el fichero de `blob` o el de la dirección `url` (blob:, data: o del propio servidor).
// Devuelve true si lo ha podido enseñar. Nunca lanza.
export async function verAdjuntoEnLaApp({ url, blob, nombre, mime } = {}, ventana) {
  const w = ventanaDe(ventana)
  if (!w) return false
  try {
    let b = blob || blobRecordado(w, url)
    if (!b && url) b = await (await w.fetch(url)).blob()
    if (!b) return false
    // El tipo de la respuesta manda; si el servidor lo dejó en «octet-stream» (lo que no sabe enseñar), el de la fila.
    const real = String(b.type || '').split(';')[0].trim().toLowerCase()
    const tipo = real && real !== 'application/octet-stream' ? b.type : (mime || b.type || '')
    return verDocumentoEnLaApp({ blob: b, nombre: nombre || 'documento', mime: tipo }, w)
  } catch (_) { return false }
}

// Instala el desvío. Solo dentro de la app nativa y una sola vez; devuelve true si lo ha instalado.
export function instalarDescargasEnLaApp(ventana) {
  const w = ventanaDe(ventana)
  if (!w || !enLaAppNativa(w) || w[MARCA]) return false
  const A = w.HTMLAnchorElement
  if (!A || !A.prototype || typeof A.prototype.click !== 'function' || !w.document) return false
  const blobs = new Map()
  w[MARCA] = { blobs }

  const U = w.URL
  if (U && typeof U.createObjectURL === 'function' && typeof U.revokeObjectURL === 'function') {
    const crear = U.createObjectURL
    const soltar = U.revokeObjectURL
    U.createObjectURL = function (obj) {
      const u = crear.call(U, obj)
      if (w.Blob && obj instanceof w.Blob) blobs.set(u, obj)
      return u
    }
    U.revokeObjectURL = function (u) {
      soltar.call(U, u)
      if (blobs.has(u)) w.setTimeout(() => blobs.delete(u), GRACIA_SOLTAR_MS)
    }
  }

  const clickDeSiempre = A.prototype.click
  const desviar = (a) => {
    if (!a || typeof a.getAttribute !== 'function' || !a.hasAttribute('download') || a.hasAttribute('data-descarga-propia')) return false
    const href = String(a.href || a.getAttribute('href') || '')
    if (!RE_DIRECCION_LOCAL.test(href)) return false
    const nombre = a.getAttribute('download') || 'documento'
    // El Blob se coge YA (antes de que quien ha pulsado suelte la dirección); si no se recuerda, se pide ahora mismo.
    const b = blobs.get(href)
    const p = b ? Promise.resolve(b) : w.fetch(href).then((r) => r.blob())
    p.then((blob) => verAdjuntoEnLaApp({ blob, nombre }, w)).catch(() => {})
    return true
  }
  A.prototype.click = function () {
    if (desviar(this)) return undefined
    return clickDeSiempre.call(this)
  }
  // Los <a download> que se PULSAN (no los de .click()): se para la descarga que no va a ocurrir y se abre el visor.
  w.document.addEventListener('click', (e) => {
    const t = e && e.target
    const a = t && typeof t.closest === 'function' ? t.closest('a[download]') : null
    if (a && desviar(a)) e.preventDefault()
  }, true)
  return true
}
